import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { useEditModeStore } from 'src/domain/stores/useEditModeStore';
import { useEventStore } from 'src/domain/stores/useEventStore';
import Colors from 'src/core/utils/Colors';

function EditButton() {
	const editMode = useEditModeStore();
	const eventStore = useEventStore();

	if (!eventStore.eventData.length) return null;

	// The pencil toggles edit mode and becomes a checkmark while edit mode is on.
	return (
		<TouchableOpacity hitSlop={{ top: 14, bottom: 14, left: 14, right: 14 }} onPress={editMode.toggle}>
			<Ionicons name={editMode.isEditing ? 'checkmark' : 'pencil'} size={20} style={styles.icon} />
		</TouchableOpacity>
	);
}

export default EditButton;

const styles = StyleSheet.create({
	icon: {
		color: Colors.black,
	},
});
